"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Credenza, CredenzaClose, CredenzaContent, CredenzaDescription, CredenzaFooter, CredenzaHeader, CredenzaTitle } from "@/components/ui/credenza";
import { emitter, type SettingsDataProviderEmitterState } from "@/lib/emitter";
export function controlFinishPodiumOrganizationSetup(properties: SettingsDataProviderEmitterState) {
  emitter.emit("settings.workspace.data_provider.finish_podium_setup", properties);
}
export function FinishPodiumOrganizationSetup() {
  const $ = _c(10);
  const [isOpen, setOpenState] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleFinishSetupEvent = t2 => {
        const {
          state
        } = t2;
        setOpenState(state === "on");
      };
      emitter.on("settings.workspace.data_provider.finish_podium_setup", handleFinishSetupEvent);
      return () => {
        emitter.off("settings.workspace.data_provider.finish_podium_setup", handleFinishSetupEvent);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpenState(false);
      controlFinishPodiumOrganizationSetup({
        data: {
          providerId: null
        },
        state: "off"
      });
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClose = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = open => {
      if (!open) {
        handleClose();
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CredenzaHeader><CredenzaTitle>Podium access required</CredenzaTitle><CredenzaDescription>Podium did not return an organization this account can access.</CredenzaDescription></CredenzaHeader>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p>To complete setup:</p>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="space-y-3 px-4 text-sm sm:px-0">{t5}<ol className="list-decimal space-y-2 pl-5 text-muted-foreground"><li>Sign in to Podium with the account used to connect this integration.</li><li>Ask a Podium administrator to give that account access to at least one active location.</li><li>Delete this incomplete Podium connection, then connect Podium again so we can discover its organizations.</li></ol></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CredenzaContent>{t4}{t6}<CredenzaFooter><CredenzaClose asChild={true}><Button variant="outline">Close</Button></CredenzaClose></CredenzaFooter></CredenzaContent>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== isOpen) {
    t8 = <Credenza onOpenChange={t3} open={isOpen}>{t7}</Credenza>;
    $[8] = isOpen;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}